module.exports = __webpack_public_path__ + "img/IEF Logo square.e98eae43.jpg";